export default {
	"0d2e1b90358febcd8bd7ee6c1f9458b1": "請選擇訂單",
	"c7353da925eb14686e47cdb32f4cf09e": "最多隻能選擇10個訂單",
	"e8be63df7edff444a7ea3e4847ca3ecf": "您的默認地址已修改，請確認以下訂單是否使用新的默認地址？",
	"1403ab59566fad05e3ad123cbbdb97ac": "取消",
	"c5a7b0ed0583e58f1f388a4c6815bfeb": "確定修改"
}
